import { Injectable } from "@angular/core";
import { domain } from "../variables/domain";
import { HttpClient, HttpErrorResponse, HttpUrlEncodingCodec } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class LoginService {
  constructor(private http: HttpClient) {}
  getUserDetails(loginform) {
    return this.http.post(domain.URL + "Login", loginform).pipe(map((res:any) => res));
  }
  Registration(Details) {
    return this.http.post(domain.URL + "Register", Details).pipe(map((res:any) => res));
  }
  UpdateUser(Details) {
    return this.http.post(domain.URL + "UpdateUser", Details).pipe(map((res:any) => res));
  }
  chanePassword(Details) {
    return this.http.post(domain.URL + "ChangePWD", Details).pipe(map((res:any) => res));
  }
  forgotPassword(Details) {
    return this.http.post(domain.URL + "ForgotPWD", Details).pipe(map((res:any) => res));
  }
  saveImage(file, userId) {
    return this.http
      .post(domain.URL + "saveProfilePic?UserId=" + userId, file)
      .pipe(map((res:any) => res));
  }
 
  removeUser(Id) {
    return this.http
      .post(domain.URL + "RemoveUser?UserId=" + Id,'')
      .pipe(map((res:any) => res));
  }

  saveOTP(UserId,smsOTP) {
    return this.http
      .post(
        domain.saveOTP + "?OTP=" + smsOTP + "&UserId=" + UserId,
        {}
      )
      .pipe(map((res:any) => res));
  }

  ValidateLoginUser(object) {
    return this.http.post(domain.ValidateLoginUser, object).pipe(map((res:any) => res));
  }

  loginWithOTP(UserId) {
    return this.http
      .post(domain.URL + "LoginAsOTP", { UserId: UserId ,Token:''})
      .pipe(map((res:any) => res));
  }
  ValidateOTP(UserId, smsOTP) {
    return this.http
      .post(domain.URL + "ValidateOTP", { UserId: UserId ,OTP: smsOTP})
      .pipe(map((res:any) => res));
  }

  ValidateSession(details) {
    return this.http.post(domain.ValidateSession, details).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return this.errorHandler(err);
      })
    );
  }
  // ValidateSession(details){
  //   return this.http
  //   .post(domain.ValidateSession, details)
  //   .map(res => {return res}),catchError((err)=>{
  //     return this.errorHandler(err);
  //   });
  // }
  SaveSession(details) {
    return this.http.post(domain.SaveSession, details).pipe(map((res:any) => res));
  }
  SignUpValidateRegOTP(details) {
    return this.http.post(domain.SignUpValidateRegOTP, details).pipe(map((res:any) => res));
  }
  SignupSendotp(details) {
    return this.http.post(domain.SignupSendotp, details).pipe(map((res:any) => res));
  }

  GetAllActiveCities() {
    return this.http
      .get(domain.URL + "GetAllActiveCities")
      .pipe(map((res: any) => res));
  }

  GetAllCity() {
    return this.http
      .get(domain.URL + "GetAllCity")
      .pipe(
        map((res: any) => res),
        catchError(() => this.GetAllActiveCities())
      );
  }

  GetAgentCity(UserId:any) {
    return this.http
      .get(domain.URL + "GetAgentCity?UserId=" + UserId)
      .pipe(map((res: any) => res));
  }
  UpdateAgentCity(details:any) {
    return this.http
      .post(domain.URL + "UpdateAgentCity", details )
      .pipe(map((res: any) => res));
  }

  // ValidateLoginUser(details) {
  //   return this.http.post(domain.ValidateLoginUser, details).pipe(map((res:any) => res));
  // }
  errorHandler(error: HttpErrorResponse) {
    return throwError(error || "server error.");
  }
}
